/**
 * seminar-widerruf.js
 * § 356 Abs. 4 BGB – Checkout-Gate und Bestellnachweis für Seminare/Workshops.
 *
 * Funktionen:
 *   - blockiert Cart-/Cart-Drawer-Checkout, bis die Widerrufsrecht-Checkbox bestätigt ist
 *   - leitet den Checkout-Button der Cart-Notification bei Seminar im Warenkorb zum Warenkorb-Gate um
 *   - schreibt versionierte Cart Attributes als Nachweis in die resultierende Shopify-Bestellung
 *   - hält den Status über AJAX-Re-Renders per sessionStorage synchron
 *
 * Sicherheit:
 *   - keine Ausgabe von User-Daten per innerHTML
 *   - nur same-origin Shopify Ajax Cart API
 *   - Attribute werden strikt über feste Keys geschrieben/gelöscht
 */
(function () {
  'use strict';

  var SETTINGS = window.seminarWiderrufSettings || {};
  var PRODUCT_TYPE = String(SETTINGS.productType || 'Seminar');
  var CART_URL = String(SETTINGS.cartUrl || '/cart');
  var CHECKOUT_URL = String(SETTINGS.checkoutUrl || '/checkout');
  var CHECKOUT_LABEL = String(SETTINGS.checkoutLabel || 'Auschecken');
  var GATE_LABEL = String(SETTINGS.gateLabel || 'Zum Warenkorb - Hinweis bestätigen');

  var STORAGE_ACCEPTED = 'fe_seminar_widerruf_accepted';
  var STORAGE_TIMESTAMP = 'fe_seminar_widerruf_accepted_at';
  var STORAGE_VERSION = 'fe_seminar_widerruf_text_version';
  var STORAGE_PRODUCTS = 'fe_seminar_widerruf_products';
  var STORAGE_ATTENTION = 'fe_seminar_widerruf_attention_required';

  var ATTR_KEYS = [
    'Seminar-Widerruf Zustimmung',
    'Seminar-Widerruf Textversion',
    'Seminar-Widerruf Zeitpunkt Client',
    'Seminar-Widerruf Rechtsgrundlage',
    'Seminar-Widerruf Produkte',
    'Seminar-Widerruf Erklärung'
  ];

  var ERROR_MSG = 'Bitte bestätige den Hinweis zum Widerrufsrecht, um fortzufahren.';
  var GATE_QUERY = 'seminar_widerruf=required';
  var lastNotificationHasSeminar = null;
  var clearTimer = null;

  function getCartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) return window.routes.cart_update_url;
    return localizedPath('cart/update.js');
  }

  function getCartJsonUrl() {
    if (window.routes && window.routes.cart_url) return String(window.routes.cart_url).replace(/\/?$/, '.js');
    return localizedPath('cart.js');
  }

  function localizedPath(path) {
    var root = '/';
    if (window.routes && window.routes.root_url) root = window.routes.root_url;
    root = String(root || '/');
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + path.replace(/^\//, '');
  }

  function safeSessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function safeSessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) { /* ignore storage restrictions */ }
  }

  function safeSessionRemove(key) {
    try { window.sessionStorage.removeItem(key); } catch (e) { /* ignore storage restrictions */ }
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function checkboxList() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-seminar-widerruf-checkbox]'));
  }

  function wrapList() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-seminar-widerruf-wrap]'));
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getWrapForCheckbox(cb) {
    return cb ? cb.closest('[data-seminar-widerruf-wrap]') : null;
  }

  function getErrorForCheckbox(cb) {
    var wrap = getWrapForCheckbox(cb);
    return wrap ? wrap.querySelector('[data-seminar-widerruf-error]') : null;
  }

  function getCheckboxesForForm(formId) {
    return checkboxList().filter(function (cb) {
      return cb.getAttribute('data-seminar-widerruf-form-id') === formId;
    });
  }

  function getPrimaryCheckboxForForm(formId) {
    var boxes = getCheckboxesForForm(formId);
    if (!boxes.length) return null;
    return boxes.find(function (cb) { return isVisible(getWrapForCheckbox(cb)); }) || boxes[0];
  }

  function getPrimaryCheckbox() {
    var boxes = checkboxList();
    if (!boxes.length) return null;
    return boxes.find(function (cb) { return isVisible(getWrapForCheckbox(cb)); }) || boxes[0];
  }

  function getTextVersion(cb) {
    var wrap = getWrapForCheckbox(cb) || document.querySelector('[data-seminar-widerruf-wrap]');
    return wrap ? String(wrap.getAttribute('data-seminar-widerruf-text-version') || '') : '';
  }

  function getProductSignature(cb) {
    var wrap = getWrapForCheckbox(cb) || document.querySelector('[data-seminar-widerruf-wrap]');
    return wrap ? String(wrap.getAttribute('data-seminar-widerruf-products') || '') : '';
  }

  function setError(cb, message) {
    var err = getErrorForCheckbox(cb);
    if (err) err.textContent = message || '';
  }

  function markInvalid(cb) {
    if (!cb) return;
    var wrap = getWrapForCheckbox(cb);
    if (wrap) wrap.classList.add('seminar-widerruf-wrap--invalid');
    setError(cb, ERROR_MSG);
  }

  function clearInvalid(cb) {
    if (!cb) return;
    var wrap = getWrapForCheckbox(cb);
    if (wrap) wrap.classList.remove('seminar-widerruf-wrap--invalid');
    setError(cb, '');
  }

  function focusAndScroll(cb) {
    if (!cb) return;
    var wrap = getWrapForCheckbox(cb);
    if (wrap && typeof wrap.scrollIntoView === 'function') {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    cb.focus({ preventScroll: true });
  }

  function setTimestampForForm(formId, timestamp) {
    var selector = '[data-seminar-widerruf-accepted-at][form="' + formId.replace(/"/g, '\\"') + '"]';
    Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function (input) {
      input.value = timestamp || '';
    });
  }

  function setTimestampForAll(timestamp) {
    Array.prototype.slice.call(document.querySelectorAll('[data-seminar-widerruf-accepted-at]')).forEach(function (input) {
      input.value = timestamp || '';
    });
  }

  function setAllCheckboxes(checked) {
    checkboxList().forEach(function (cb) {
      cb.checked = checked;
      if (checked) clearInvalid(cb);
    });
  }

  function collectAttributesFromCheckbox(cb) {
    var wrap = getWrapForCheckbox(cb);
    var attrs = {};
    if (!wrap) return attrs;

    attrs['Seminar-Widerruf Zustimmung'] = cb.checked ? 'Ja' : '';

    Array.prototype.slice.call(wrap.querySelectorAll('[data-seminar-widerruf-attribute]')).forEach(function (input) {
      var match = String(input.name || '').match(/^attributes\[(.+)]$/);
      if (match && ATTR_KEYS.indexOf(match[1]) !== -1) {
        attrs[match[1]] = cb.checked ? String(input.value || '') : '';
      }
    });

    return attrs;
  }

  function clearSeminarAttributes() {
    var attrs = {};
    ATTR_KEYS.forEach(function (key) { attrs[key] = ''; });
    return updateCartAttributes(attrs);
  }

  function updateCartAttributes(attrs) {
    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {
      // Hidden form-associated inputs remain the checkout-time fallback.
    });
  }

  function persistAcceptance(cb) {
    if (!cb) return;
    updateCartAttributes(collectAttributesFromCheckbox(cb));
  }

  function restoreState(cb) {
    if (!cb) return;
    var version = getTextVersion(cb);
    var accepted = safeSessionGet(STORAGE_ACCEPTED) === '1' && safeSessionGet(STORAGE_VERSION) === version && safeSessionGet(STORAGE_PRODUCTS) === getProductSignature(cb);
    var timestamp = accepted ? safeSessionGet(STORAGE_TIMESTAMP) : '';

    cb.checked = accepted;
    if (timestamp) setTimestampForForm(cb.getAttribute('data-seminar-widerruf-form-id'), timestamp);
    if (accepted) {
      clearInvalid(cb);
    } else if (safeSessionGet(STORAGE_ACCEPTED) === '1') {
      safeSessionRemove(STORAGE_ACCEPTED);
      safeSessionRemove(STORAGE_TIMESTAMP);
      safeSessionRemove(STORAGE_VERSION);
      safeSessionRemove(STORAGE_PRODUCTS);
      clearSeminarAttributes();
    }
  }

  function handleCheckboxChange(cb) {
    var checked = !!cb.checked;
    var version = getTextVersion(cb);
    var timestamp = checked ? (safeSessionGet(STORAGE_TIMESTAMP) || nowIso()) : '';

    safeSessionSet(STORAGE_ACCEPTED, checked ? '1' : '0');
    safeSessionSet(STORAGE_VERSION, version);
    safeSessionSet(STORAGE_PRODUCTS, getProductSignature(cb));
    if (checked) safeSessionSet(STORAGE_TIMESTAMP, timestamp);
    else safeSessionRemove(STORAGE_TIMESTAMP);

    setAllCheckboxes(checked);
    setTimestampForAll(timestamp);

    if (checked) clearInvalid(cb);
    else markInvalid(cb);

    persistAcceptance(cb);
  }

  function initCheckbox(cb) {
    if (!cb || cb.dataset.seminarWiderrufInit === '1') return;
    cb.dataset.seminarWiderrufInit = '1';
    restoreState(cb);
    cb.addEventListener('change', function () { handleCheckboxChange(cb); });
  }

  function initAllCheckboxes() {
    checkboxList().forEach(initCheckbox);
  }

  function ensureAcceptedBeforeSubmit(formId) {
    var cb = getPrimaryCheckboxForForm(formId);
    if (!cb) return true;

    if (!cb.checked) {
      markInvalid(cb);
      focusAndScroll(cb);
      return false;
    }

    var timestamp = safeSessionGet(STORAGE_TIMESTAMP) || nowIso();
    safeSessionSet(STORAGE_ACCEPTED, '1');
    safeSessionSet(STORAGE_VERSION, getTextVersion(cb));
    safeSessionSet(STORAGE_PRODUCTS, getProductSignature(cb));
    safeSessionSet(STORAGE_TIMESTAMP, timestamp);
    setTimestampForAll(timestamp);
    clearInvalid(cb);
    persistAcceptance(cb);
    return true;
  }

  function fetchCart() {
    return fetch(getCartJsonUrl(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) { return response.json(); });
  }

  function cartHasSeminar(cart) {
    return !!(cart && cart.items && cart.items.some(function (item) {
      return String(item.product_type || '') === PRODUCT_TYPE;
    }));
  }

  function cartHasSeminarAttrs(cart) {
    var attrs = cart && cart.attributes ? cart.attributes : {};
    return ATTR_KEYS.some(function (key) { return !!attrs[key]; });
  }

  function scheduleStaleAttributeClear() {
    window.clearTimeout(clearTimer);
    clearTimer = window.setTimeout(function () {
      if (checkboxList().length) return;
      fetchCart().then(function (cart) {
        if (!cartHasSeminar(cart)) {
          safeSessionRemove(STORAGE_ACCEPTED);
          safeSessionRemove(STORAGE_TIMESTAMP);
          safeSessionRemove(STORAGE_VERSION);
          safeSessionRemove(STORAGE_PRODUCTS);
          safeSessionRemove(STORAGE_ATTENTION);
          if (cartHasSeminarAttrs(cart)) clearSeminarAttributes();
        }
      }).catch(function () { /* ignore network errors */ });
    }, 500);
  }

  function gateToCart() {
    safeSessionSet(STORAGE_ATTENTION, '1');
    var separator = CART_URL.indexOf('?') === -1 ? '?' : '&';
    window.location.href = CART_URL + separator + GATE_QUERY + '#seminar-widerruf-wrap-cart';
  }

  function submitNotificationForm(form) {
    if (!form) {
      window.location.href = CHECKOUT_URL;
      return;
    }

    if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '';
      form.appendChild(input);
    }

    HTMLFormElement.prototype.submit.call(form);
  }

  function notificationMarkerValue() {
    var button = document.getElementById('cart-notification-button');
    if (button && button.hasAttribute('data-seminar-widerruf-cart-has-seminar')) {
      return button.getAttribute('data-seminar-widerruf-cart-has-seminar') === 'true';
    }

    var marker = document.querySelector('#cart-notification-button [data-seminar-widerruf-cart-has-seminar]');
    if (!marker) return null;
    return marker.getAttribute('data-seminar-widerruf-cart-has-seminar') === 'true';
  }

  function updateNotificationButton(hasSeminar) {
    var button = document.querySelector('[data-seminar-widerruf-notification-checkout]');
    if (!button) return;

    lastNotificationHasSeminar = hasSeminar;
    button.textContent = hasSeminar ? GATE_LABEL : CHECKOUT_LABEL;
    button.setAttribute(
      'aria-label',
      hasSeminar ? 'Zum Warenkorb gehen und Hinweis zum Widerrufsrecht bestätigen' : CHECKOUT_LABEL
    );
  }

  function configureCartNotification() {
    var marker = notificationMarkerValue();
    if (marker !== null) {
      updateNotificationButton(marker);
      return;
    }

    var notification = document.getElementById('cart-notification');
    if (!notification || !notification.classList.contains('active')) return;

    fetchCart().then(function (cart) {
      updateNotificationButton(cartHasSeminar(cart));
    }).catch(function () { /* keep default checkout behavior */ });
  }

  function handleNotificationCheckout(event, button) {
    var form = button.closest('#cart-notification-form');
    var marker = notificationMarkerValue();
    var hasKnownSeminar = marker !== null ? marker : lastNotificationHasSeminar;

    if (hasKnownSeminar === true) {
      event.preventDefault();
      event.stopImmediatePropagation();
      gateToCart();
      return;
    }

    if (hasKnownSeminar === false) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    fetchCart().then(function (cart) {
      if (cartHasSeminar(cart)) gateToCart();
      else submitNotificationForm(form);
    }).catch(function () {
      window.location.href = CART_URL;
    });
  }

  function maybeShowAttentionFromUrl() {
    var params = new URLSearchParams(window.location.search || '');
    if (params.get('seminar_widerruf') !== 'required' && safeSessionGet(STORAGE_ATTENTION) !== '1') return;

    safeSessionRemove(STORAGE_ATTENTION);

    window.setTimeout(function () {
      var cb = getPrimaryCheckbox();
      if (!cb) return;
      markInvalid(cb);
      focusAndScroll(cb);
    }, 150);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[name="checkout"]');
    if (!button) return;

    if (button.closest('#cart-notification-form')) {
      handleNotificationCheckout(event, button);
      return;
    }

    var formId = button.getAttribute('form') || (button.form && button.form.id);
    if (!formId) return;

    if (!ensureAcceptedBeforeSubmit(formId)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.id) return;

    if (form.id === 'cart-notification-form') {
      if (notificationMarkerValue() === true || lastNotificationHasSeminar === true) {
        event.preventDefault();
        event.stopImmediatePropagation();
        gateToCart();
      }
      return;
    }

    if (form.id !== 'cart' && form.id !== 'CartDrawer-Form') return;

    if (!ensureAcceptedBeforeSubmit(form.id)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    initAllCheckboxes();
    configureCartNotification();
    maybeShowAttentionFromUrl();
    scheduleStaleAttributeClear();

    var observer = new MutationObserver(function () {
      initAllCheckboxes();
      configureCartNotification();
      if (!checkboxList().length) scheduleStaleAttributeClear();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
